/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { RestoreAzureDiskRequest } from '../models/RestoreAzureDiskRequest';

export class RestoreAzureVMInstanceConfig {
  /**
  * The size of the VM to restore
  */
  'vmSize'?: string;
  /**
  * The Name of the network interface to use
  */
  'networkInterface'?: string;
  /**
  * Optional tags to apply to the output instance
  */
  'tags'?: { [key: string]: string; };
  'diskSettings'?: Array<RestoreAzureDiskRequest>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "vmSize",
      "baseName": "vmSize",
      "type": "string",
      "format": ""
    },
    {
      "name": "networkInterface",
      "baseName": "networkInterface",
      "type": "string",
      "format": ""
    },
    {
      "name": "tags",
      "baseName": "tags",
      "type": "{ [key: string]: string; }",
      "format": ""
    },
    {
      "name": "diskSettings",
      "baseName": "diskSettings",
      "type": "Array<RestoreAzureDiskRequest>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RestoreAzureVMInstanceConfig.attributeTypeMap;
  }

  public constructor() {
  }
}

